import { getAppSetting, saveAppSetting } from "../db/appSettingsRepo";

const CONSENT_KEY = "voice.transcription-consent.v1";

export async function hasTranscriptionConsent(): Promise<boolean> {
  const consent = await getAppSetting<{ acceptedAt?: string }>(CONSENT_KEY);
  return typeof consent?.acceptedAt === "string";
}

export async function acceptTranscriptionConsent(): Promise<void> {
  await saveAppSetting(CONSENT_KEY, { acceptedAt: new Date().toISOString() });
}
